var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M9 18h18","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M21 12l6 6-6 6","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Arrow.defaultProps = {"viewBox":"0 0 36 36","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
